export default "__VITE_ASSET__DB9FXrN7__"